import { server_ip } from "../config";
async function updateManyEventsByFilter(token,filter, data) {
    try {
        const response = await fetch(`${server_ip}/api/events/update-many`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
export {
    updateManyEventsByFilter
}